"use strict";
import {
  addClassWithScroll as scroll
} from "./common/_scroll-event";
import {
  addClassWithScrollSingleElement as singleScroll
} from "./common/_scroll-event";

/**
 * スクロールイベント登録
 */
window.addEventListener(
  "scroll",
  function () {
    scroll(
      ".interview-department--01 .department-merit__item",
      ".interview-department--01 .department-merit",
      "is-anime",
      "4"
    );
    scroll(
      ".interview-department--02 .department-merit__item",
      ".interview-department--02 .department-merit",
      "is-anime",
      "4"
    );
    scroll(
      ".interview-department--03 .department-merit__item",
      ".interview-department--03 .department-merit",
      "is-anime",
      "4"
    );
    singleScroll(
      ".interview-department__merit",
      "is-anime",
      "4"
    );
    singleScroll(
      ".mask",
      "is-anime",
      "4"
    );
    singleScroll(
      ".talk-article__item",
      "is-anime",
      "4"
    );
    singleScroll(
      ".talk-article__ttl",
      "is-anime",
      "4"
    );
    singleScroll(
      ".summarize__border",
      "is-anime",
      "4"
    );
    singleScroll(
      ".summarize__ttl",
      "is-anime",
      "4"
    );
    singleScroll(
      ".summarize__txt",
      "is-anime",
      "4"
    );
  },
  false
);
